import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.InsuranceAreaController;
const getController = self.customSetting.getInsuranceArea;
const postController = self.customSetting.postInsuranceArea;

export default {
  // 2-12
  getInsForChoice: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryPeople`)
        .then((res) => {
          context.commit("GET_INSCHOICE_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addInsApplier: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsPeople`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getInsApplier: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryInsuranceList`)
        .then((res) => {
          context.commit("GET_INSAPPLIER_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 2-13
  getInsForCensor: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryInsuranceVertifyList`)
        .then((res) => {
          context.commit("GET_INSCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  approveIns: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/ApproveInsurance`, data)
        .then((res) => {
          context.commit("GET_INSCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  rejectIns: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/RejectInsurance`, data)
        .then((res) => {
          context.commit("GET_INSCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
